import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}dekiloknaller/`;

const title = "Holy Road - The Discounter";
const description = "Both settlers and Palestinians buy their chicken at Rami Levy, the cheapest supermarket in the area. But the low-priced grocery store is located in a settlement. The Jews are allowed weapons, the Palestinians are not.";
const featuredImage = `${imageFolder}dekiloknaller/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}dekiloknaller`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/248452827"
    },
    {
        type: "Paragraph",
        text: "The Israeli – Palestinian conflict is visible throughout the entire occupied West Bank, but at the Rami Levy supermarket, in the illegal Jewish settlement Gush Etzion, a different struggle is being fought; a permanent war over the lowest prices. At the height of the struggle, a kilo of chicken cost less than a shekel (24 eurocent)."
    },
    {
        type: "Paragraph",
        text: "Even though this supermarket is located next to a roundabout where there have been multiple attacks, one has to realize that chicken is chicken. In their villages surrounding these settlements Palestinians can go to the hairdresser for a fair price and a falafel sandwich is not expensive either, but no one can beat prize butcher Rami Levy."
    },
    {
        type: "Paragraph",
        text: "On 19 November 2015 Mohammed Abdel Basset al-Kharoub opened fire on cars at the roundabout while his fellow villagers were buying kilos of chicken amid armed Israeli settlers some 100 meters down the street. The settlers were also buying their chicken at Rami Levy. You can't miss a good bargain."
    },
    {
        type: "Paragraph",
        text: "Unlike most other places in the occupied West Bank, Jews and Arabs live among each other here. Some Palestinians have come to the conclusion that it might be worth trying to live together with the Jewish occupiers rather than to fight them. Reluctantly they do their shopping at the settlements, and even the employees at Rami Levy are Palestinians. But don't talk about it with your fellow villagers."
    }
]


// WEBPACK FOOTER //
// ./src/data/stories/story2.js